export const urls = {
  GET_VRSTE_USLUGA: 'Combo/vrati_vrste_usluga_combo',
  GET_DELOVI_COMBO: 'Combo/vrati_delove_combo',
  VRATI_STAVKE_ZA_RN:
    'DokRNServisniStavkeDelovi/vrati_stavke_delovi_za_dok_rn_servisni',
  INSERT_STAVKE:
    'DokRNServisniStavkeDelovi/unos_stavke_delovi_za_dok_rn_servisni',
  UPDATE_STAVKE:
    'DokRNServisniStavkeDelovi/izmena_stavke_delovi_za_dok_rn_servisni',
  DELETE_STAVKE:
    'DokRNServisniStavkeDelovi/brisanje_stavke_delovi_za_dok_rn_servisni',
  INSERT_DOKUMENTA: 'Dokumenta/unos_dokumenta',
  GET_DOKUMENT: 'Dokumenta/vrati_dokumenta_objekta',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
};
